/**
 * Picker modal for CZNA-367 external-identifier lookup results.
 * Shows a loading state, a clickable list of candidates, or — when the
 * registry returned nothing — a link to search the registry's own website
 * manually (`fallbackSearchUri`, built server-side per source).
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, Button, Icon } from '@folio/stripes/components';
var listItemButtonStyle = {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '8px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    marginBottom: '6px',
    cursor: 'pointer',
    background: '#fff',
    font: 'inherit',
};
var ExternalIdentifierPickerModal = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, isLoading = _a.isLoading, isError = _a.isError, result = _a.result, onSelect = _a.onSelect;
    var intl = useIntl();
    var candidates = (_b = result === null || result === void 0 ? void 0 : result.candidates) !== null && _b !== void 0 ? _b : [];
    return (React.createElement(Modal, { open: open, onClose: onClose, label: intl.formatMessage({ id: 'ui-czna-authorities.externalIdentifierLookup.modalTitle' }), dismissible: true, size: "small", footer: (React.createElement(Button, { onClick: onClose }, intl.formatMessage({ id: 'ui-czna-authorities.recordPicker.close' }))) },
        isLoading && (React.createElement("div", { role: "status", "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.externalIdentifierLookup.loading' }), style: { textAlign: 'center', padding: '16px' } },
            React.createElement(Icon, { icon: "spinner-ellipsis" }))),
        !isLoading && isError && (React.createElement("div", { role: "alert", style: { color: '#d0021b', padding: '8px' } }, intl.formatMessage({ id: 'ui-czna-authorities.externalIdentifierLookup.error' }))),
        !isLoading && !isError && candidates.length === 0 && (React.createElement("div", { style: { padding: '8px' } },
            React.createElement("p", null, intl.formatMessage({ id: 'ui-czna-authorities.externalIdentifierLookup.noResults' })),
            (result === null || result === void 0 ? void 0 : result.fallbackSearchUri) && (React.createElement("a", { href: result.fallbackSearchUri, target: "_blank", rel: "noopener noreferrer" }, intl.formatMessage({ id: 'ui-czna-authorities.externalIdentifierLookup.searchExternally' }))))),
        !isLoading && !isError && candidates.length > 0 && (React.createElement("ul", { style: { listStyle: 'none', margin: 0, padding: 0 } }, candidates.map(function (c) { return (React.createElement("li", { key: c.identifier },
            React.createElement("button", { type: "button", style: listItemButtonStyle, onClick: function () { return onSelect(c.identifier, c.uri); } }, c.label))); })))));
};
export default ExternalIdentifierPickerModal;
